import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_GladosInterface = {
    vv1: {
        updateNavigatorKnowledgeBaseVersion: {
            method: HttpMethod.GET,
            path: '/v1/glados-interface/update-navigator-knowledge-base-version',
            timeout: Minute * 5
        },
        getNLPFindings: {
            method: HttpMethod.POST,
            path: '/v1/glados-interface/get-nlp-findings',
            timeout: Minute * 5
        },
        getGladosLogs: {
            method: HttpMethod.GET,
            path: '/v1/glados-interface/get-glados-logs',
            timeout: Minute * 5
        }
    }
};
//# sourceMappingURL=apis.js.map